// extracted by mini-css-extract-plugin
export default {"main":"Home_main__LiiNd","btnprimary":"Home_btnprimary__1tcZe"};